import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ToastController, LoadingController } from 'ionic-angular';

import { ImcpaAppProvider } from '../../../providers/imcpaApp/imcpaApp';
import { ViewResourcePage } from '../viewResource/viewResource';
// import { InAppBrowser } from '@ionic-native/in-app-browser';

@Component({
  selector: 'page-resourcesList',
  templateUrl: 'resourcesList.html',
  // styleUrls: [ 'resourcesList.scss', '../../theme/variables.scss' ]

})
export class ResourcesListPage {
  public resources = [];
  public key: any;
 
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    // private iab: InAppBrowser,
    public myApp: ImcpaAppProvider

  ) {
      this.initializeItems();
        // this.goshalas = this.myApp.getGoshalas();
      // this.getGoshalas();
      // console.log(this.goshalas);
  }

  initializeItems() {
    this.resources = this.myApp.getResources();
  }

  getItems(ev: any) {

    // Reset items back to all of the items
    this.initializeItems();

    // set val to the value of the searchbar
    const val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.resources = this.resources.filter((goshala) => {
        return (goshala.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
  }

  OpenUrl(resource){
    // window.open("http://google.com",'_system', 'location=yes');
  // const browser = this.iab.create('resource.bookLink');
  // browser.show()
  }

    goToViewResourcePage(resource){
    this.navCtrl.push(ViewResourcePage, {resource: resource});
  }

}



// WEBPACK FOOTER //
// ./src/pages/resources/resourceList/resourcesList.ts